import { ClickAwayListener, Divider, Grow, MenuItem, MenuList, Paper, Popper, } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Wrapper, Button } from './DropDownButton.styles';
import React, { useRef, useState } from 'react';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { rem } from '@innovyze/stylovyze/lib/utils/styles';
const addKey = (option, i) => ({
    ...option,
    key: i,
});
/**
 * Add a description for your component here
 */
export const DropDownButton = ({ height = 36, width = 109, options, className, switchSelected, arrow, variant, color, placement, initialSelectedIndex, fitButtonToContent, fitMenuToContent, popupZIndex, disabled, buttonProps, }) => {
    const [selectedIndex, setSelectedIndex] = useState(initialSelectedIndex ? initialSelectedIndex : 0);
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);
    const selected = options[selectedIndex];
    const menuOptions = options.map(addKey);
    const toggleDropdown = () => {
        setOpen(!open);
    };
    const handleMenuItemClick = (index) => (event) => {
        event.stopPropagation();
        const selectedMenuItem = options[index];
        selectedMenuItem.onClick && selectedMenuItem.onClick();
        if (switchSelected)
            setSelectedIndex(index);
        setOpen(false);
    };
    const useMenuItemStyles = makeStyles(() => ({
        menuItem: {
            width: fitMenuToContent ? 'auto' : rem(width),
            minWidth: rem(width),
        },
    }));
    const classes = useMenuItemStyles();
    return (React.createElement(Wrapper, { ref: anchorRef },
        React.createElement(Button, { height: height, width: fitButtonToContent ? 'auto' : rem(width), onClick: toggleDropdown, variant: variant, color: color, className: className, disabled: disabled, "data-test-id": "dropdown-button", "data-cy": selected.cy, ...buttonProps },
            selected.name,
            arrow && React.createElement(ExpandMore, null),
            React.createElement(Popper, { open: open, anchorEl: anchorRef.current, placement: placement, transition: true, style: { zIndex: popupZIndex ? popupZIndex : 'auto' } }, ({ TransitionProps }) => (React.createElement(Grow, { ...TransitionProps },
                React.createElement(Paper, { square: true },
                    React.createElement(ClickAwayListener, { onClickAway: e => {
                            if (anchorRef.current &&
                                anchorRef.current.contains(e.target)) {
                                return;
                            }
                            setOpen(false);
                        } },
                        React.createElement(MenuList, null, menuOptions.map(({ name, icon, cy, key, disabled: optionDisabled, divider, }, i) => i !== selectedIndex ? (React.createElement("div", { key: i },
                            divider && React.createElement(Divider, null),
                            React.createElement(MenuItem, { className: classes.menuItem, key: `menu-item-${name}`, selected: i ===
                                    selectedIndex, onClick: handleMenuItemClick(key), 
                                // eslint-disable-next-line prettier/prettier
                                disabled: optionDisabled, "data-cy": cy },
                                icon,
                                name))) : null))))))))));
};
DropDownButton.defaultProps = {
    variant: 'outlined',
    arrow: true,
    switchSelected: true,
    color: 'primary',
    placement: 'bottom-start',
};
export default DropDownButton;
